import ReactDOM from "react-dom";
import styled from "styled-components/macro";
import { CSSTransition } from "react-transition-group";

const ModalWrapper = styled.div`
  position: fixed;
  z-index: ${({ theme }) => theme.zIndex["9999"]};
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s ease-in-out;
  pointer-events: none;

  &.enter-done {
    opacity: 1;
    pointer-events: visible;
  }

  &.exit {
    opacity: 0;
  }

  .modal-content {
    width: min-content;
    /* width: 500px; */
    /* background-color: #fff; */
    transform: translateY(-200px);
    transition: all 0.3s ease-in-out;
  }

  &.enter-done .modal-content {
    transform: translateY(0);
  }

  &.exit .modal-content {
    transform: translateY(-200px);
  }
`;

export default function Modal(props) {
  const { show, onClose, children } = props;
  return ReactDOM.createPortal(
    <CSSTransition in={show} unmountOnExit timeout={{ enter: 0, exit: 300 }}>
      <ModalWrapper onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          {children}

          {/* 
          
          <div className="modal-header">
            <h4 className="modal-title">Modal Title</h4>
          </div>

          <div className="modal-body">This is modal content</div>

          <div className="modal-footer">
            <button onClick={onClose} className="button">
              Close
            </button>
          </div>
          */}
        </div>
      </ModalWrapper>
    </CSSTransition>,
    document.getElementById("root")
  );
}
